var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"font-weight-bold caption"},[_c('v-chip',{attrs:{"label":"","outlined":"","small":"","color":_vm.primaryColor}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.text)?_c('span',{staticClass:"ml-2 my-auto"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }